import { createSlice } from '@reduxjs/toolkit';

export interface AuthState {
  isLoggedIn: boolean;
  token: string | null;
  currentUser: any;
}

const initialState: AuthState = {
  isLoggedIn: !!localStorage.getItem('token'),
  token: localStorage.getItem('token'),
  currentUser: {
    tenDangNhap: 'Username',
    hoTen: 'Người dùng',
    tenDonVi: '',
  }
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginUser: (state, {payload}) => {
      localStorage.setItem('token', payload.token);
      state.token = payload.token;
      localStorage.setItem('user', JSON.stringify(payload));
      state.currentUser = payload;
      state.isLoggedIn = true;
    },
    loadUser(state, { payload }) {
      state.currentUser = payload;
    },
    logoutUser: (state) => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('menu');
      state.token = null;
      state.currentUser = {};
      state.isLoggedIn = false;
    },
  }
});

export const { loginUser, loadUser, logoutUser } = authSlice.actions;

export default authSlice.reducer;
